import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { ReturnTypeEnum } from "../return";
import { OpensearchPaginationCursorSchema } from "../tables/table";
import { AdvancedFilterDataSchema } from "../views/views";

export const ReturnTableInputSchema = z.object({
  advancedFiltersData: z.array(AdvancedFilterDataSchema),
  type: createEnum(ReturnTypeEnum).optional(),
  sort: z
    .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
    .nullish(),
  search: z.string().nullish(),
  barcode: z.string().nullish(),
  merchantTimezone: z.string().nullish(),
  opensearchToken: OpensearchPaginationCursorSchema.nullish(),
});

export type ReturnTableInput = z.infer<typeof ReturnTableInputSchema>;
